import "./Insights.module.css";
import ToppmenyOchKontakt from "@/reusable_sections/Header";
import ProgressInField from "./sections/ProgressInField";
import CalculateYourProfit from "./sections/CalculateYourProfit";
import Footer from "@/reusable_sections/Footer";
export default function InsightsPage() {
  return <div>
      <ToppmenyOchKontakt />
      <ProgressInField />
      <CalculateYourProfit />
      <Footer />
    </div>;
}